import { TableHeading } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import styled from 'styled-components';

export const TableHeadingStyled = styled(TableHeading)`
  padding: 1.6rem 0;
  background-color: ${TABLE_HEADER_BG_COLOR};

  &:first-child {
    padding-left: 2.4rem;
    padding-right: 1rem;
  }

  &:nth-child(3) {
    padding-left: 1rem;
  }
`;
